import './standard-teaser.scss';

import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';

class StandardTeaser {
    constructor ($element) {
        this.$standardTeaserRoot = $element;
        this.$standardTeaserSlider = this.$standardTeaserRoot.querySelector('[data-standard-teaser-slider="slider"]');
        this.$slides = this.$standardTeaserRoot.querySelectorAll('[data-standard-teaser-slider="slide"]');
        this.$slidePrev = this.$standardTeaserRoot.querySelector('.slider-controls__prev');
        this.$slideNext = this.$standardTeaserRoot.querySelector('.slider-controls__next');
        this.$pagination = this.$standardTeaserRoot.querySelector('.slider-controls__pagination');
        this.$sliderControls = this.$standardTeaserRoot.querySelector('[data-slider-controls]');
        this.slider = null;
        this.sliderActive = false;
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    setEvents () {
        [1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.sliderActive = true;

        this.slider = new Swiper(this.$standardTeaserSlider, {
            modules: [Pagination, Navigation, A11y],
            slidesPerView: 'auto',
            spaceBetween: 0,
            initialSlide: 0,
            speed: 1000,
            slideClass: 'standard-teaser__item',
            wrapperClass: 'standard-teaser__items-inner',
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$slideNext,
                prevEl: this.$slidePrev,
                disabledClass: 'slider-controls__disabled'
            },
            on: {
                slideChangeTransitionStart: () => {
                    this.$pagination?.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    this.$pagination?.classList.remove('is--active');
                }
            }
        });
    }

    checkSize () {
        if (window.mediaMatchHandler[1024].matches && this.$slides.length <= 4) {
            this.destroySlider();
        } else {
            if (window.mediaMatchHandler[768].matches && this.$slides.length < 3) {
                this.destroySlider();
            } else {
                if (this.slider === null && !this.sliderActive) {
                    this.initSlider();
                }
            }
            console.log(window.mediaMatchHandler[320].matches, this.$slides.length > 1);
            if (window.mediaMatchHandler[320].matches && this.$slides.length > 1) {
                if (this.slider === null && !this.sliderActive) {
                    this.initSlider();
                }
            }
        }
    }

    destroySlider () {
        this.sliderActive = false;
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.$sliderControls?.setAttribute('data-controls-active', 'false');
        }
    }
}

export { StandardTeaser };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$standardTeaserSliders = $context.querySelectorAll('[data-standard-teaser-slider="root"]');

        if ($$standardTeaserSliders.length > 0) {
            $$standardTeaserSliders.forEach((standardTeaserSlider) => {
                const $standardTeaserSlider = new StandardTeaser(standardTeaserSlider);
                $standardTeaserSlider.initialize();
            });
        }
    }
});
